import React from "react";
import ExecutorPhotos from './ExecutorPhotos';
import ComplaintList from "./ComplaintList";
import AcceptWork from "./AcceptWork";

export default (props) => {
    const {
        isLoggedIn,
        executor,
        isCustomer,
        uploadWorks,
        uploadState,
        currentUserId,
        deleteImageInServer,
        deleteVideoInServer,
        currentOrder,
        settings,
    } = props;

    if(executor.status === 7) return false;

    let newExecutorPhotos = executor.photos && executor.photos.results.map((item) => {return {src: item.image || '', ...item}}) || [];

    let objectList = [];
    let workDidArray = [];
    (currentOrder.orderposition_set || []).map((object) => {
        let order_object = object.order_object || {};
        let order_method = object.order_method || {};
        let method_type = order_method.method_type || {};
        let photos = (newExecutorPhotos || []).filter(ph => ph.position_id === object.id);
        let videos = executor.videos && executor.videos.results.filter(ph => ph.position_id === object.id) || [];

        if(method_type.is_video && videos.length) workDidArray.push(true); 
        else if(!method_type.is_video && photos.length) workDidArray.push(true); 
        
        objectList.push({
            order_position: {...object},
            title: order_object.title || 'Имя объекта не указана',
            id: object.id,
            photos: photos,
            videos: videos,
        })
    });

    let workDidBool = workDidArray.some(item => item === true);

    return (
        <div className="order-result">
            
            <ExecutorPhotos
                newExecutorPhotos={newExecutorPhotos}
                isCustomer={isCustomer}
                isLoggedIn={isLoggedIn}
                executor={executor}
                objectList={objectList}
                currentUserId={currentUserId}
                inputTypeFileValue={props.inputTypeFileValue}
                uploadWorks={uploadWorks}
                uploadState={uploadState}
                deleteImageInServer={deleteImageInServer}
                deleteVideoInServer={deleteVideoInServer}
                endShootingDatetime={props.endShootingDatetime}
                currentOrder={currentOrder}
                settings={settings}
                dateForSettingsBoolean={props.dateForSettingsBoolean}
            />

            {
                (executor.status >= 4 && executor.status <= 6)
                ?
                <ComplaintList
                    isCustomer={isCustomer}
                    executorStatus={executor.status}
                    complaints={executor.complaints} />
                : null
            }

            {
                isCustomer ?
                <AcceptWork
                    workDidBool={workDidBool}
                    orderStatus={currentOrder.status}
                    openPopup={props.openArbitragePopup}
                    handleAcceptWork={props.handleAcceptWork}
                    executor={executor}
                />
                : null
            }
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/Result.js